define([
    "../../hereMapsModule",
    "angular",
    "../../../arrays/arrays",
    "text!./nlgRouteHere.html",
], function (hereMapsModule, angular, arrays, nlgRouteHereView) {
    "use strict";

    return hereMapsModule.directive("nlgRouteHere", [function () {
        return {
            restrict: "E",
            template: nlgRouteHereView,
            scope: {
                routes: "=?",
                selectedMapRouteMarkers: "=?",
                canProgram: "<?",
                onSaveSuccess: "&?",
                hasTooltipInNearby: "<?",
                hereConfig: "=?",
                onRegisterApi: "=?",
            },
            controller: [
                "$scope",
                "$rootScope",
                "$timeout",
                "$templateCache",
                "$compile",
                "$http",
                "hereMapsService",
                "hereMapsLoadingService",
                "mapsDirectionsService",
                "hereMapsMarkersFactory",
                "hereMapsRoutesFactory",
                "nlgRouteMarkerHereService",
                "routeStopModalService",
                "routeServiceUrl",
                "messagesModal",
                "routingSelectionDialog",
                "OptimizationSource",
                "FlowType",
                "loadingService",
                "pathService",
                "remoteExceptionHandler",
                "violationModal",
                "MoveStopAction",
                function (
                    $scope,
                    $rootScope,
                    $timeout,
                    $templateCache,
                    $compile,
                    $http,
                    hereMapsService,
                    hereMapsLoadingService,
                    mapsDirectionsService,
                    hereMapsMarkersFactory,
                    hereMapsRoutesFactory,
                    nlgRouteMarkerHereService,
                    routeStopModalService,
                    routeServiceUrl,
                    messagesModal,
                    routingSelectionDialog,
                    OptimizationSource,
                    FlowType,
                    loadingService,
                    pathService,
                    remoteExceptionHandler,
                    violationModal,
                    MoveStopAction) {

                    $scope.stopSequenceByTrip = {};
                    $scope.hasModification = false;
                    $scope.routesHereApi = null;
                    $scope.isShowingTable = true;
                    $scope.originalRoutes = angular.copy($scope.routes);
                    $scope.routesWithStopsChanged = [];
                    $scope.routeMarkersForSelection = {};

                    $rootScope.selectedHereMapsRouteMarkersModel = $scope.selectedMapRouteMarkers;


                    var alterStopsUrl = routeServiceUrl.getAlterStopsUrl();
                    var alterStopsDetails = {};
                    var routeDataByTripPresentationNodeId = {};

                    $scope.onRegisterRoutesHereApi = function (api) {
                        $scope.routesHereApi = api;
                        $scope.routesHereApi.setMarkerDragendAction(dragendAction);
                        $scope.routesHereApi.setTapAction(tapAction);

                        var hasTooltip = !!$scope.hasTooltipInNearby;
                        $scope.routesHereApi.setHasTooltipInNearbyMarkersBubble(hasTooltip);

                        if ($scope.onRegisterApi) {
                            $scope.onRegisterApi({
                                setRoutes: function (routes) {
                                    $scope.routes = routes;
                                },
                                getNearbyRoutesMarker: function (event) {
                                    return $scope.routesHereApi.getNearbyRoutesMarker(event);
                                },
                                openNearbyRoutesBubble: function (nearbyRoutesMarkers, event, callback) {
                                    $scope.routesHereApi.openNearbyRoutesBubble(nearbyRoutesMarkers, event, callback);
                                },
                                syncRoutesOpacityWithSelection: function (selectedTripIds) {
                                    $scope.routesHereApi.syncRoutesOpacityWithSelection(selectedTripIds);
                                },
                                setOnRouteSelect: function (func) {
                                    $scope.routesHereApi.setOnRouteSelect(func);
                                },
                                toggleRouteMarkersByModel: nlgRouteMarkerHereService.toggleMarkersByModel,
                                cleanMapRoutesMarkersSelection: nlgRouteMarkerHereService.cleanSelection
                            });
                        }
                    };

                    $scope.tripPanel = function () {
                        $scope.$applyAsync(function () {
                            $scope.isShowingTable = !$scope.isShowingTable;
                            $timeout(function () {
                                var map = hereMapsService.getMap();
                                if (map) {
                                    map.getViewPort().resize();
                                }
                            }, 100);
                        });
                    };

                    $scope.saveChanges = function () {
                        if ($scope.routesWithStopsChanged.length === 0) {
                            return messagesModal("dialog.warning", [{
                                keyBundle: "alterStopsModal.violation.noAlteration",
                                parameters: []
                            }]);
                        }

                        return routingSelectionDialog({
                            source: OptimizationSource.MANUAL_OPERATION,
                            flow: FlowType.ANALYSIS,
                            trips: getTripIds(),
                            dus: [],
                            single: true
                        }).then(function (configs) {
                            return loadingService($http.post(pathService.getPath("alter-stop-trips"), {
                                alterations: getAlterations(),
                                routingConfigId: configs.routingConfig.id
                            })).catch(remoteExceptionHandler())
                                .then(function (response) {
                                    return violationModal(response.data);
                                }).then(function (manualOperationResult) {
                                    return loadingService($http.post(pathService.getPath("manualOperation-save"), manualOperationResult.token));
                                }).then(function () {
                                    return messagesModal("dialog.success", [{
                                        keyBundle: "alterStopsModal.success",
                                        parameters: []
                                    }]);
                                }).then(function () {
                                    $scope.hasModification = false;
                                    $scope.routesWithStopsChanged = [];
                                    $scope.stopSequenceByTrip = {};
                                    if($scope.onSaveSuccess){
                                        $scope.onSaveSuccess();
                                    }
                                });
                        });
                    };

                    function getTripIds() {
                        return $scope.routesWithStopsChanged.map(function (route) {
                            return route.presentationNode.id;
                        });
                    }

                    function getAlterations() {
                        return $scope.routesWithStopsChanged.map(function (route) {
                            return {
                                tripNodeIdentifier: route.presentationNode,
                                sequence: $scope.stopSequenceByTrip[route.presentationNode.id]
                            };
                        });
                    }

                    $scope.cancelChanges = function () {
                        if ($scope.routesHereApi && $scope.here.routesData.routesHere) {
                            $scope.here.routesData.routesHere.forEach(function (routeHere) {
                                $scope.routesHereApi.clearRoute(routeHere);
                            });
                        }
                        $scope.here.routesData.routesHere = [];
                        routeDataByTripPresentationNodeId = {};

                        $scope.routesWithStopsChanged = [];
                        $scope.hasModification = false;
                        $scope.stopSequenceByTrip = {};
                        $scope.routes = angular.copy($scope.originalRoutes);
                    };

                    $scope.here = getHere();

                    function getHere() {
                        if (!$scope.hereConfig) {
                            return getDefaultMode();
                        }
                        $scope.hereConfig.routesData = $scope.hereConfig.routesData || {
                            routes: [],
                            routesHere: [],
                            onRegisterApi: $scope.onRegisterRoutesHereApi
                        };
                        return $scope.hereConfig;
                    }

                    function getDefaultMode() {
                        return {
                            maps: {
                                hasFullScreen: false,
                                possibleButtons: {
                                    hasTripPanel: true,
                                },
                            },
                            routesData: {
                                routes: [],
                                routesHere: [],
                                onRegisterApi: $scope.onRegisterRoutesHereApi,
                                tripPanel: $scope.tripPanel,
                                isShowingTable: function () {
                                    return $scope.isShowingTable;
                                }
                            }
                        };
                    }

                    $scope.$watch("routes", setRoutes);

                    function setRoutes() {
                        if (!$scope.routes || $scope.routes.length === 0) {
                            cleanUpRoutes();
                            return;
                        }

                        if (!$scope.hasModification) {
                            $scope.originalRoutes = angular.copy($scope.routes);
                        }
                        cleanUpRoutes();
                        hereMapsLoadingService.start();

                        mapsDirectionsService($scope.routes).then(function (routesDirections) {
                            $scope.here.routesData.routes = routesDirections;

                            $scope.here.routesData.routes.forEach(function (route, index) {
                                var stopSequenceOnTrip = [];
                                route.stopSequenceOnTrip = route.stops.map(function (stop) {
                                    stopSequenceOnTrip.push(stop.sequenceOnTrip);
                                });
                                $scope.stopSequenceByTrip[route.presentationNode.id] = stopSequenceOnTrip;


                                var routeHere = createRoute(route, true);
                                if (!routeHere) {
                                    return;
                                }

                                $scope.here.routesData.routesHere.push(routeHere);
                                collectRouteMarkersForSelection(routeHere);
                                loadAlterStopDetails(route);
                                routeDataByTripPresentationNodeId[getTripPresentationNodeId(route)] = {
                                    routeHere: routeHere,
                                    index: index
                                };
                            });

                        }).then(function () {
                            if($scope.here.routesData.routesHere.length === 0) {
                                return;
                            }
                            $scope.routesHereApi.addRoutes($scope.here.routesData.routesHere);
                            nlgRouteMarkerHereService.setStopMarkerById($scope.routeMarkersForSelection);
                        }).finally(function () {
                            hereMapsLoadingService.stop();
                        });
                    }

                    function cleanUpRoutes() {
                        if ($scope.here.routesData.routes.length === 0) {
                            return;
                        }
                        alterStopsDetails = {};
                        $scope.here.routesData.routes = [];
                        $scope.here.routesData.routesHere = [];
                        routeDataByTripPresentationNodeId = {};
                        $scope.routesHereApi.clearRoutes();
                        $scope.routeMarkersForSelection = {};
                    }

                    function reDrawRoutes(routes) {
                        if (!routes || routes.length === 0) {
                            return;
                        }
                        hereMapsLoadingService.start();

                        mapsDirectionsService(routes).then(function (routesDirections) {

                            routesDirections.forEach(function (route) {
                                var routeHere = createRoute(route, true);

                                if(!routeHere){
                                    return;
                                }

                                var routeData = routeDataByTripPresentationNodeId[getTripPresentationNodeId(route)];

                                var oldRouteHere = routeData.routeHere;
                                var indexRouteHere = routeData.index;

                                $scope.routesHereApi.clearRoute(oldRouteHere);
                                routeData.routeHere = routeHere;

                                $scope.here.routesData.routesHere[indexRouteHere] = routeHere;
                                $scope.routesHereApi.addRoutes([routeHere]);
                            });
                        }).finally(function () {
                            hereMapsLoadingService.stop();
                        });
                    }

                    function createRoute(route) {
                        if (!route.selected) {
                            route.selected = true;
                        }

                        route.presentationTreeSelected = false;

                        route.presentationNode = getPresentationNode(route, "original");

                        route.markersData = {
                            markersPoints: getMarkersPoints(route),
                            draggable: isDraggable(route)
                        };

                        var data = {
                            presentationNode: route.presentationNode,
                            routeTripCode: route.tripCode,
                            markers: hereMapsMarkersFactory.createMarkers(route.markersData)
                        };

                        return hereMapsRoutesFactory.createRoute(route, data);
                    }

                    function loadAlterStopDetails(route) {
                        if (!canAlterStops(route)) {
                            return;
                        }

                        $http.get(alterStopsUrl + getTripPresentationNodeId(route)).then(function (stopsParam) {
                            alterStopsDetails[getTripPresentationNodeId(route)] = stopsParam.data;
                        });
                    }


                    function canAlterStops(route) {
                        return $scope.canProgram && route.presentationNode.type.name.toLowerCase() === "trip";
                    }

                    function collectRouteMarkersForSelection(routeHere) {
                        var data = routeHere.getData();
                        var markers = data.markers;
                        markers.forEach(function (marker) {
                           var markerData = marker.getData();
                           $scope.routeMarkersForSelection[markerData.id] = marker;
                        });
                    }

                    function getTripPresentationNodeId(route) {
                        return route.presentationNode.id;
                    }

                    function getPresentationNode(route, legType) {
                        return {
                            id: route.presentationNode.id,
                            type: {
                                messageKey: route.presentationNode.type.messageKey,
                                name: route.presentationNode.type.name,
                                legType: legType
                            },
                            version: route.presentationNode.version
                        };
                    }

                    function getMarkersPoints(route) {
                        return route.stops.map(function (stop) {
                            return {
                                geographicInfo: stop.address.geographicInfo,
                                data: {
                                    id: stop.id,
                                    routeId: route.tripCode,
                                    routePresentationNode: route.presentationNode,
                                    tripCode: route.tripCode,
                                    geographicInfo: stop.address.geographicInfo,
                                    stop: stop,
                                    color: route.color,
                                    stopInfo: {
                                        tripCode: route.tripCode,
                                        stopNumber: stop.stopIconText,
                                        stopName: stop.stopName,
                                        stopAddress: stop.address,
                                        eta: stop.arrivalTime,
                                        plate: route.truckPlate,
                                        weight: stop.additionalInfo.weight,
                                        volume: stop.additionalInfo.volume,
                                        loadedDuration: stop.loadedDuration,
                                        unloadedDuration: stop.unloadedDuration,
                                    }
                                }
                            };
                        });
                    }

                    function isDraggable(route) {
                        return route.tripStatus === "br.com.neolog.model.trip.TripStatus.ALLOCATED";
                    }

                    function tapAction(markerData) {
                        var event = markerData.event;
                        var markerHere = event.target;
                        if (event.originalEvent.ctrlKey) {
                            nlgRouteMarkerHereService.toggleMarkers([markerHere]);
                            return;
                        }
                        var data = markerData.marker.getData();
                        var coordinate = {
                            lat: data.geographicInfo.latitude,
                            lng: data.geographicInfo.longitude
                        };
                        routeStopModalService.openBubble(coordinate, data);
                    }

                    function dragendAction(dragendContext) {
                        var targetStopMarker = dragendContext.marker;
                        var event = dragendContext.event;

                        var nearbyRoutesMarker = $scope.routesHereApi.getNearbyRoutesMarker(event);

                        var nearbyMarkersWithoutTarget = nearbyRoutesMarker.filter(function (marker) {
                            return marker.getData().id !== targetStopMarker.getData().id;
                        });

                        if( !isValidToMove(targetStopMarker) ) {
                            return messagesModal("dialog.error", [{
                                keyBundle: "route.stopOperation.thereIsStopsSelected",
                            }]).finally( function () {
                                setOriginMarkerPosition(targetStopMarker);
                            });
                        }

                        if (nearbyMarkersWithoutTarget.length > 0) {
                            program(targetStopMarker, nearbyMarkersWithoutTarget, event);
                        }
                        setOriginMarkerPosition(targetStopMarker);
                    }

                    function isValidToMove(targetStopMarker) {
                        if ( $scope.selectedMapRouteMarkers.length ===0 ){
                            return true;
                        }
                        return $scope.selectedMapRouteMarkers.some( function (routeMarker) {
                            return routeMarker.stop.id === targetStopMarker.getData().stop.id;
                        });
                    }

                    function setOriginMarkerPosition(target) {
                        var data = target.data;
                        target.setGeometry(
                            {
                                lat: data.geographicInfo.latitude,
                                lng: data.geographicInfo.longitude
                            }
                        );
                    }

                    function program(targetStopMarker, nearbyRoutesMarker, event) {
                        if (nearbyRoutesMarker.length === 1) {
                            var uniqueStopMarker = nearbyRoutesMarker[0];
                            changeStop(targetStopMarker, targetStopMarker.getData().routeId,
                                uniqueStopMarker, uniqueStopMarker.getData().routeId);
                        } else {
                            $scope.routesHereApi.openNearbyMarkersBubble(nearbyRoutesMarker, event, function(selectedMarker) {
                                changeStop(targetStopMarker, targetStopMarker.getData().routeId,
                                    selectedMarker, selectedMarker.getData().routeId);
                            });
                        }
                    }

                    function changeStop(fromStopMarker, fromStopTripId, toStopMarker, toStopTripId) {
                        if (fromStopTripId === toStopTripId) {
                            changeStopsOnSameTrip(fromStopMarker, toStopMarker);
                        } else {
                            changeStopsOnDistinctTrips(fromStopMarker, toStopMarker);
                        }
                    }

                    function getRouteFromTripCode(stopData) {
                        return $scope.here.routesData.routes.find(function (route) {
                            return route.tripCode === stopData.tripCode;
                        });
                    }

                    function changeStopsOnSameTrip(fromMarkerStop, toStopMarker) {
                        var fromMarkerStopData = fromMarkerStop.getData();
                        var toMarkerStopData = toStopMarker.getData();

                        var tripRoute = getRouteFromTripCode(fromMarkerStopData);
                        var tripPresentationNodeId = getTripPresentationNodeId(tripRoute);

                        var fromIndex = fromMarkerStopData.stop.sequenceOnTrip;
                        var toIndex = toMarkerStopData.stop.sequenceOnTrip;

                        if (canMove(fromIndex, toIndex, tripPresentationNodeId)) {
                            var sequenceAux = fromIndex;
                            tripRoute.stops[fromIndex].sequenceOnTrip = toIndex;
                            tripRoute.stops[toIndex].sequenceOnTrip = sequenceAux;

                            arrays.swap(tripRoute.stops, fromIndex, toIndex);
                            arrays.swap(alterStopsDetails[tripPresentationNodeId], fromIndex, toIndex);
                            arrays.swap($scope.stopSequenceByTrip[tripRoute.presentationNode.id], fromIndex, toIndex);

                            $scope.routesWithStopsChanged.push(tripRoute);

                            reDrawRoutes([tripRoute]);
                            $scope.hasModification = hasModification();
                        } else {
                            messagesModal("dialog.error", [{
                                keyBundle: "alterStops.error.loadUnloadDependency",
                                parameters: [(fromIndex + 1), (toIndex + 1)]
                            }]);
                        }
                    }

                    function canMove(index1, index2, tripPresentationNodeId) {
                        var smallerIndex = Math.min(index1, index2);
                        var greaterIndex = Math.max(index1, index2);
                        return canMoveDown(smallerIndex, greaterIndex, tripPresentationNodeId)
                            && canMoveUp(smallerIndex, greaterIndex, tripPresentationNodeId);
                    }

                    function canMoveDown(smallerIndex, greaterIndex, tripPresentationNodeId) {
                        var stopOrigin = alterStopsDetails[tripPresentationNodeId][smallerIndex];
                        //slice -> fim não inclusivo, por isso o +1
                        var stopsToCheck = alterStopsDetails[tripPresentationNodeId].slice(smallerIndex + 1, greaterIndex + 1);
                        var possible = false;

                        arrays.each(stopsToCheck, function (down) {
                            possible = arrays.disjoint(stopOrigin.loadedDeliveryUnits, down.unloadedDeliveryUnits);
                            if (!possible) {
                                return arrays.each.BREAK;
                            }
                        });
                        return possible;
                    }

                    function canMoveUp(smallerIndex, greaterIndex, tripPresentationNodeId) {
                        var stopOrigin = alterStopsDetails[tripPresentationNodeId][greaterIndex];
                        var stopsToCheck = alterStopsDetails[tripPresentationNodeId].slice(smallerIndex, greaterIndex);
                        stopsToCheck = stopsToCheck.reverse();
                        var possible = false;

                        arrays.each(stopsToCheck, function (up) {
                            possible = arrays.disjoint(stopOrigin.unloadedDeliveryUnits, up.loadedDeliveryUnits);
                            if (!possible) {
                                return arrays.each.BREAK;
                            }
                        });
                        return possible;
                    }

                    function changeStopsOnDistinctTrips(fromMarkerStop, toStopMarker) {
                        if (hasModification()) {
                            messagesModal("dialog.error", [{
                                keyBundle: "route.stopOperation.shouldConfirmSequenceAlteration"
                            }]);
                            return;
                        }

                        var fromMarkerStopData = fromMarkerStop.getData();
                        var toMarkerStopData = toStopMarker.getData();

                        var fromTrip = getRouteFromTripCode(fromMarkerStopData);
                        var toTrip = getRouteFromTripCode(toMarkerStopData);

                        var stopsIds = getStopIdsToMoveStopAction(fromMarkerStopData);

                        var action = new MoveStopAction(fromTrip.presentationNode, toTrip.presentationNode, stopsIds, toMarkerStopData.id);
                        action.perform().then(
                            function () {
                                $scope.onSaveSuccess();
                            }
                        );
                    }

                    function hasModification() {
                        var hasModification = false;
                        Object.values($scope.stopSequenceByTrip).forEach(function (sequenceOnTrip) {
                            var previusValue = null;
                            sequenceOnTrip.forEach(function (currentValue) {
                                if (previusValue !== null && previusValue + 1 !== currentValue) {
                                    hasModification = true;
                                }
                                previusValue = currentValue;
                            });
                        });
                        return hasModification;
                    }

                    function getStopIdsToMoveStopAction(stop) {
                        if ($scope.selectedMapRouteMarkers.length === 0){
                            return [stop.id];
                        }
                        var stopsIds = [];
                        $scope.selectedMapRouteMarkers.forEach(function (routeMarker) {
                            stopsIds.push(routeMarker.stop.id);
                        });
                        return stopsIds;
                    }
                }
            ]
        };
    }]);
});